/**
 * Dr. Matt custom homepage — scroll reveal animations
 * Fixes: all .dm-home sections scanned; content visible if JS/CSS missing
 */
(function () {
  if (typeof window === 'undefined') return;

  function showAllAnimated() {
    document.querySelectorAll('[data-dm-animate]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function initDmHome() {
    var isDesignMode =
      (window.Shopify && Shopify.designMode) ||
      document.documentElement.classList.contains('shopify-design-mode');

    if (isDesignMode) {
      document.documentElement.classList.add('dm-home-design-mode');
      showAllAnimated();
      return;
    }

    var items = document.querySelectorAll('[data-dm-animate]');
    if (!items.length) return;

    document.documentElement.classList.add('dm-home-js');

    if (!('IntersectionObserver' in window)) {
      showAllAnimated();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -5% 0px', threshold: 0.05 }
    );

    items.forEach(function (el, i) {
      el.style.transitionDelay = Math.min(i * 0.05, 0.35) + 's';
      observer.observe(el);
    });

    /* Elements already in viewport on load */
    requestAnimationFrame(function () {
      items.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          el.classList.add('is-visible');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDmHome);
  } else {
    initDmHome();
  }
})();
